import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useThemeUI } from 'theme-ui';
import { createContext, useContext } from 'react';
import { Container, Palette } from '@uswitch/ev-core/react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
export var ModuleWrapperContext = /*#__PURE__*/createContext({
  alreadyWrapped: false,
  childSpacing: false,
  spacingTop: 'lg',
  spacingBottom: 'lg'
});
export var ModuleWrapperProvider = ModuleWrapperContext.Provider;

var getFirstDefined = function getFirstDefined() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.find(function (arg) {
    return typeof arg !== 'undefined';
  });
};

var nonZero = function nonZero(x) {
  return x === 0 || x === '0' || x === '0px' ? 0.05 : x;
};

export default (function (_ref) {
  var _theme$container, _theme$container2;

  var _ref$useContainer = _ref.useContainer,
      useContainer = _ref$useContainer === void 0 ? true : _ref$useContainer,
      _ref$childSpacing = _ref.childSpacing,
      childSpacing = _ref$childSpacing === void 0 ? false : _ref$childSpacing,
      spacingTopProp = _ref.spacingTop,
      spacingBottomProp = _ref.spacingBottom,
      children = _ref.children,
      className = _ref.className;
  var wrapperContext = useContext(ModuleWrapperContext);

  var _useThemeUI = useThemeUI(),
      _useThemeUI$theme = _useThemeUI.theme,
      theme = _useThemeUI$theme === void 0 ? {} : _useThemeUI$theme;

  var contentCols = (theme === null || theme === void 0 ? void 0 : (_theme$container = theme.container) === null || _theme$container === void 0 ? void 0 : _theme$container.contentCols) || 12;
  var contentSpan = (theme === null || theme === void 0 ? void 0 : (_theme$container2 = theme.container) === null || _theme$container2 === void 0 ? void 0 : _theme$container2.contentSpan) || 12; // const fallback = wrapperContext.alreadyWrapped ? 0 : 'lg'

  var fallback = 0; // nonZero to prevent margin collapse

  var spacingTop = nonZero(getFirstDefined(wrapperContext.spacingTop, spacingTopProp, fallback));
  var spacingBottom = nonZero(getFirstDefined(wrapperContext.spacingBottom, spacingBottomProp, fallback));
  var spacingSx = {
    paddingTop: spacingTop,
    paddingBottom: spacingBottom
  };
  var contents = useContainer && !wrapperContext.alreadyWrapped ? _jsx(Container, {
    cols: contentCols,
    span: contentSpan,
    sx: {
      variant: 'layout.container.moduleWrapper'
    },
    children: children
  }) : spacingTop || spacingBottom ? children : children;
  return _jsx(ModuleWrapperContext.Provider, {
    value: {
      alreadyWrapped: true,
      childSpacing: childSpacing
    },
    children: wrapperContext.alreadyWrapped && wrapperContext.childSpacing ? _jsx("div", {
      sx: spacingSx,
      className: className,
      children: contents
    }) : wrapperContext.alreadyWrapped ? contents : _jsx(Palette, {
      as: "div",
      sx: _objectSpread({
        width: '100%'
      }, spacingSx),
      px: {
        backgroundColor: 'backgroundColor'
      },
      className: className,
      children: contents
    })
  });
});
//# sourceMappingURL=module-wrapper.js.map